import { render, staticRenderFns } from "./addAd.vue?vue&type=template&id=4994c1d0&"
import script from "./addAd.vue?vue&type=script&lang=js&"
export * from "./addAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports